import axios from 'axios';
import store from '../store';
import router from '../router';
import { Message, Notification } from 'element-ui'

axios.defaults.baseURL = '/api'
//自定义配置axios的拦截器
axios.interceptors.request.use(
    config  => {
        if (config.method == 'post' && config.data) {
            //分页参数处理成url连接参数
            let pageParam = '';
            let pageNum = config.data.pageNum;
            if (pageNum !== undefined && pageNum != null) {
                pageParam += ('pageNum='+pageNum);
            }

            let pageSize = config.data.pageSize;
            if (pageSize !== undefined && pageSize != null) {
                pageParam += (pageParam.length == 0? "":"&" + ('pageSize='+pageSize));
            }

            pageParam = (config.url.includes('?') ? "" : "?") + pageParam;
            config.url += pageParam;
        }
        return config;
    },
    err => {
        return Promise.reject(err);
    }
);

axios.interceptors.response.use(
    response => {
        //请求成功的，对响应进行拆包，返回自定义包装类
        if (response.headers && response.headers['content-type'] === 'application/json;charset=UTF-8') {
            return Promise.resolve(response.data);
        } else {
            return Promise.resolve(response);
        }
    },
    err => {
        if (err && err.response && err.response.status === 403) {
            // console.debug("权限不足");
            JSON.stringify(store.state.userInfo) === '{}' ? router.replace("/login") : router.replace("/403");
        } else if (err && err.response && err.response.status != 200) {
            // console.log(err)
            // this.$meesage.error("请求失败。。。");
            Message({
                message: '请求失败',
                type: 'error'
            })
        }
        return Promise.reject(err);
    }
);

export default axios;
